import * as React from 'react';
import { ISvgAtomProps } from './Atoms.interfaces';

const FavoritesButton: React.FC<ISvgAtomProps> = ({ width = 16, height = 16 }) => {
  return (
    <svg x={0} y={0} width={width} height={height} viewBox="0 0 16 16">
      <g transform="translate(0 0)">
        <path
          d="M7.99977601,1.98762972 L8.22293609,1.76968093 C8.89968177,1.13866329 10.0431532,0.333333333 11.4732397,0.333333333 C11.9732911,0.333333333 12.4716958,0.432959734 12.9541823,0.63071814 C14.337969,1.19559983 15.3375229,2.22374429 15.7684125,3.52486509 C16.2942624,5.11340805 15.9177143,6.94304691 14.709028,8.67754255 C12.4332726,11.9413034 8.44493705,14.0957244 8.27642356,14.1858863 L7.99977601,14.3333333 L7.72367736,14.1858863 C7.55516387,14.0957244 3.56682836,11.9413034 1.29107291,8.67704442 C0.0818376889,6.94404317 -0.294161462,5.11390619 0.231688445,3.52486509 C0.662577983,2.22424242 1.66158303,1.19559983 3.04536968,0.63071814 C3.52840509,0.433457866 4.0268098,0.333333333 4.52686122,0.333333333 C5.95728299,0.333333333 7.10163479,1.13959344 7.77792837,1.77077367 L7.99977601,1.98762972 Z"
          transform="translate(0 1)"
          fill="#FFB6C160"
        />
      </g>
    </svg>
  );
};

export default FavoritesButton;
